import {
  UPDATE_DOCUMENT_FORMAT_FILE,
  UPDATE_DOCUMENT_ACCESS_LEVEL_FILE,
  UPDATE_DOCUMENT_CONFERENCE_TYPE_FILE,
  UPDATE_DOCUMENT_LEGAL_POSSIBILITY_FILE,
  INSERT_CONFERENCE_TYPE_OPTIONS_DATA,
  INSERT_LEGAL_POSSIBILITY_OPTIONS_DATA,
  INSERT_DOCUMENT_TYPE_DOCUMENT_TABLE,
  INSERT_DOCUMENT_TABLE_ROW_BY_DOCUMENT_TYPE,
  UPDATE_DOCUMENT_TABLE_BY_DOCUMENT_TYPE
} from '../actions/actionTypes';

const initialState = {
  documentacaoFileSelectedOptions: {},
  enumFormatoArquivo: {
    digitalizado: {
      value: '1',
      text: 'Digitalizado'
    },
    natoDigital: {
      value: '2',
      text: 'Nato-digital'
    }
  },
  enumNivelAcesso: {
    restrito: {
      value: '1',
      text: 'Restrito'
    },
    publico: {
      value: '2',
      text: 'Público'
    }
  },
  tipoConferenciaOptionsData: [],
  hipoteseLegalOptionsData: [],
  tabelaDocumentos: {}
};

export const documentacaoFileInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DOCUMENT_FORMAT_FILE:
      const formato = {
        value: action.newValue,
        text: action.newValue
          ? action.newValue === state.enumFormatoArquivo.digitalizado.value
            ? state.enumFormatoArquivo.digitalizado.text
            : state.enumFormatoArquivo.natoDigital.text
          : ''
      };

      const formatNewData = { ...state.documentacaoFileSelectedOptions };
      formatNewData[action.key] = {
        ...formatNewData[action.key],
        formato: formato
      };

      return {
        ...state,
        documentacaoFileSelectedOptions: formatNewData
      };
    case UPDATE_DOCUMENT_ACCESS_LEVEL_FILE:
      const nivelAcesso = {
        value: action.newValue,
        text: action.newValue
          ? action.newValue === state.enumNivelAcesso.restrito.value
            ? state.enumNivelAcesso.restrito.text
            : state.enumNivelAcesso.publico.text
          : ''
      };

      const accessLevelNewData = { ...state.documentacaoFileSelectedOptions };
      accessLevelNewData[action.key] = {
        ...accessLevelNewData[action.key],
        nivelAcesso: nivelAcesso
      };

      return {
        ...state,
        documentacaoFileSelectedOptions: accessLevelNewData
      };

    case UPDATE_DOCUMENT_CONFERENCE_TYPE_FILE:
      const tipoConferencia = {
        value: action.newValue,
        text: action.newValue
          ? state.tipoConferenciaOptionsData.filter(
              (x) => x.id === parseInt(action.newValue)
            )[0].text
          : ''
      };

      const conferenceTypeNewData = {
        ...state.documentacaoFileSelectedOptions
      };
      conferenceTypeNewData[action.key] = {
        ...conferenceTypeNewData[action.key],
        tipoConferencia: tipoConferencia
      };

      return {
        ...state,
        documentacaoFileSelectedOptions: conferenceTypeNewData
      };

    case UPDATE_DOCUMENT_LEGAL_POSSIBILITY_FILE:
      const hipoteseLegal = {
        value: action.newValue,
        text: action.newValue
          ? state.hipoteseLegalOptionsData.filter(
              (x) => x.id === parseInt(action.newValue)
            )[0].text
          : ''
      };

      const legalPossibilityNewData = {
        ...state.documentacaoFileSelectedOptions
      };
      legalPossibilityNewData[action.key] = {
        ...legalPossibilityNewData[action.key],
        hipoteseLegal: hipoteseLegal
      };

      return {
        ...state,
        documentacaoFileSelectedOptions: legalPossibilityNewData
      };
    case INSERT_CONFERENCE_TYPE_OPTIONS_DATA:
      return {
        ...state,
        tipoConferenciaOptionsData: action.newValue
      };

    case INSERT_LEGAL_POSSIBILITY_OPTIONS_DATA:
      return {
        ...state,
        hipoteseLegalOptionsData: action.newValue
      };

    case INSERT_DOCUMENT_TYPE_DOCUMENT_TABLE:
      const documentsTable = {};
      for (let type in action.newValue) {
        const id = action.newValue[type].id;

        if (state.tabelaDocumentos[id])
          documentsTable[id] = state.tabelaDocumentos[id];
        else documentsTable[id] = [];
      }

      return {
        ...state,
        tabelaDocumentos: documentsTable
      };
    case INSERT_DOCUMENT_TABLE_ROW_BY_DOCUMENT_TYPE:
      const documentTableObjects = { ...state.tabelaDocumentos };
      if (documentTableObjects[action.key])
        documentTableObjects[action.key] = [
          ...documentTableObjects[action.key],
          action.newValue
        ];
      else documentTableObjects[action.key] = [action.newValue];

      return {
        ...state,
        tabelaDocumentos: documentTableObjects
      };

    case UPDATE_DOCUMENT_TABLE_BY_DOCUMENT_TYPE:
      const updatedDocumentTableObjects = { ...state.tabelaDocumentos };
      updatedDocumentTableObjects[action.key] = action.newValue;

      return {
        ...state,
        tabelaDocumentos: updatedDocumentTableObjects
      };
    default:
      return state;
  }
};
